import type { DeskDef } from "@agency/shared";
import type Phaser from "phaser";

/** A subtle highlight/glow on a desk when it is occupied. */
export class DeskView {
  private readonly highlight: Phaser.GameObjects.Rectangle;

  constructor(scene: Phaser.Scene, desk: DeskDef) {
    this.highlight = scene.add.rectangle(desk.seat.x, desk.seat.y, 18, 18, 0x7bd4ff, 0).setDepth(3);
  }

  setOccupied(occupied: boolean): void {
    this.highlight.setFillStyle(0x7bd4ff, occupied ? 0.16 : 0);
    this.highlight.setStrokeStyle(1, 0x7bd4ff, occupied ? 0.7 : 0);
  }
}
